<template>
  <div class="row col-12">
    <div class="col-12 col-md-12">
      <b-tabs pills nav-class="abas-player mb-4" content-class="" align="right">
    <b-tab title-item-class="mr-2 mt-2" active>
      <template slot="title">
        Player 1
      </template>

      <topico-video :ementa-curso="ementaCurso"></topico-video>
    </b-tab>
    <b-tab title-item-class="mt-2">
      <template slot="title">
        Player 2
      </template>

      <topico-video-s3 :ementa-curso="ementaCurso"></topico-video-s3>
    </b-tab>
    </b-tabs>
    </div>
  </div>
</template>
<script>
import TopicoVideo from '@/modules/SalaAula/components/topicos/TopicoVideo'
import TopicoVideoS3 from '@/modules/SalaAula/components/topicos/TopicoVideoS3'

export default {
  name: 'TopicoPlayers',
  components: { TopicoVideo, TopicoVideoS3 },
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  }
}
</script>
